import { render, staticRenderFns } from "./BaseDefault.vue?vue&type=template&id=1f495b11"
import script from "./BaseDefault.vue?vue&type=script&lang=js"
export * from "./BaseDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports